import { LoadablePaint } from '@confluence/loadable';

export const AuditLogLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-AuditLogContainer" */ './AuditLog')).AuditLog,
});
